import { useStore, setCurrentOrganizationId } from "./appStore";
import { useMatch } from "react-router";
import { useEffect } from "react";

// This should map the OrganizationID in the route into State
// This means that navigation will update state, but state won't update navigation. Okay for now?

export const UrlToStateMapper = () => {

    var urlData = useMatch("/Organizations/:orgId/:subRoute");
    var urlOrg = urlData?.params?.orgId;



    useEffect(() => {
        var parsedOrg = 0
        var orgIsInt = false;

        try {
            parsedOrg = parseInt(urlOrg);
            orgIsInt = true;
        } catch (ex) {

        }

        if (!isNaN(parsedOrg) && parsedOrg !== 0 && orgIsInt === true)
            setCurrentOrganizationId(parsedOrg);
    }, [urlOrg])

    return <></>
}
